
import { Vue, Component, Inject } from 'vue-property-decorator';
import { ShipFrom, ShipTo } from '@/features/shipment/types';
import { getCountryNameFromCode } from '@/features/shipment/helpers/createShipment';

@Component
export default class ShippingAddress extends Vue {
  @Inject({ default: false }) readonly isEstimatePage!: boolean;

  get fromAddress(): ShipFrom {
    if (this.isEstimatePage) {
      return this.$store.state.estimate.estimateData.fromAddress;
    }
    return this.$store.getters.getShipFromInProgress;
  }

  get toAddress(): ShipTo {
    if (this.isEstimatePage) {
      return this.$store.state.estimate.estimateData.toAddress;
    }
    return this.$store.getters.getShipToInProgress;
  }

  private getCountryName = getCountryNameFromCode;
}
